import { render, staticRenderFns } from "./CMInsuranceFilter.vue?vue&type=template&id=585b9756"
import script from "./CMInsuranceFilter.vue?vue&type=script&lang=js"
export * from "./CMInsuranceFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports